<template>
  <div class="employee-editor big">
    <div class="flex between" style="padding-right: 20px">
      <div class="page_title">{{ routeQuery.is_add | isAddText }}</div>
      <el-button type="primary" @click="back" style="width: 120px"
        >返回</el-button
      >
    </div>

    <div style="padding: 20px">
      <div class="container">
        <div class="employee-title">
          账户信息
          <el-button
            type="primary"
            size="mini"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('637') : false
            "
            @click="getStaffProportionList"
            >编辑提成比例</el-button
          >
        </div>

        <div class="employee-info">
          <el-form
            label-position="right"
            label-width="100px"
            :rules="employeeFormRules"
            ref="employeeFormRef"
            :model="employeeForm"
          >
            <el-form-item label="员工账号:" prop="phone">
              <el-input
                v-model="employeeForm.phone"
                clearable
                placeholder="请输入员工手机号"
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item label="员工姓名:" prop="recommender_name">
              <el-input
                v-model="employeeForm.recommender_name"
                clearable
                placeholder="请输入员工姓名"
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item label="员工编号:" prop="recommender_code">
              <el-input
                v-model="employeeForm.recommender_code"
                clearable
                :disabled="routeQuery.is_add == 0 ? true : false"
                placeholder="请输入员工编号"
                autocomplete="off"
              ></el-input>
            </el-form-item>

            <el-form-item label="区域经理:" class="select-staff">
              <template v-if="employeeForm.district_manager_name">
                <span>{{ employeeForm.district_manager_name }}</span>
                <span style="margin: 0 10px">{{
                  employeeForm.district_manager
                }}</span>
                <span style="margin-right: 10px">{{
                  employeeForm.district_manager_phone
                }}</span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="delStaff('district_manager')"
                  >删除</el-button
                >
              </template>
              <el-button
                type="primary"
                size="small"
                @click="openStaffList('district_manager')"
                >选择员工</el-button
              >
            </el-form-item>

            <el-form-item label="大区副总:" class="select-staff">
              <template v-if="employeeForm.area_deputy_manager_name">
                <span>{{ employeeForm.area_deputy_manager_name }}</span>
                <span style="margin: 0 10px">{{
                  employeeForm.area_deputy_manager
                }}</span>
                <span style="margin-right: 10px">{{
                  employeeForm.area_deputy_manager_phone
                }}</span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="delStaff('area_deputy_manager')"
                  >删除</el-button
                >
              </template>

              <el-button
                type="primary"
                size="small"
                @click="openStaffList('area_deputy_manager')"
                >选择员工</el-button
              >
            </el-form-item>

            <el-form-item label="大区总经理:" class="select-staff">
              <template v-if="employeeForm.area_manager_name">
                <span>{{ employeeForm.area_manager_name }}</span>
                <span style="margin: 0 10px">{{
                  employeeForm.area_manager
                }}</span>
                <span style="margin-right: 10px">{{
                  employeeForm.area_manager_phone
                }}</span>
                <el-button
                  type="primary"
                  size="mini"
                  @click="delStaff('area_manager')"
                  >删除</el-button
                >
              </template>

              <el-button
                type="primary"
                size="small"
                @click="openStaffList('area_manager')"
                >选择员工</el-button
              >
            </el-form-item>

            <el-form-item class="info-btns">
              <el-button @click="resetForm()" size="medium">重 置</el-button>
              <el-button type="primary" @click="saveForm()" size="medium"
                >保 存</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <div class="employee-title">指标信息</div>
        <div class="add-indicators">
          <el-button
            type="primary"
            @click="addIndicators()"
            size="medium"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('504') : false
            "
            >添加指标</el-button
          >
        </div>
        <el-table
          v-loading="tableLoading"
          ref="employeeTableRef"
          :data="employeeTable"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            v-for="item in tableHead"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
          >
            <template slot-scope="scope">
              {{ scope.row[item.prop] }}
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="editBtn(scope.row)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('504') : false
                "
                >编辑</el-button
              >
              <el-button
                type="text"
                @click="delBtn(scope.row)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('651') : false
                "
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="footer-pagination">
          <pagination
            v-show="totalNum > 0"
            :total="totalNum"
            :page.sync="pagination.page"
            :limit.sync="pagination.pageNumber"
            @pagination="searchList"
          />
        </div>
      </div>
    </div>

    <!-- 添加指标弹框 -->
    <el-dialog
      class="dialog-indicators"
      width="30%"
      title="编辑指标"
      :visible.sync="dialogIndicators"
    >
      <el-form
        label-position="right"
        :model="indicatorsForm"
        :rules="indicatorsRules"
        ref="indicatorsFormRef"
      >
        <el-form-item
          label="指标时限:"
          prop="indicators_timelimit"
          label-width="100px"
        >
          <el-date-picker
            v-model="indicatorsForm.indicators_timelimit"
            type="daterange"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          class="indicators-box"
          label="指标:"
          prop="target_money"
          label-width="100px"
        >
          <el-input
            v-model="indicatorsForm.target_money"
            placeholder="请输入指标"
            autocomplete="off"
          ></el-input>
          <p class="unit">元</p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelIndicatorsBtn" size="medium">取 消</el-button>
        <el-button type="primary" @click="saveIndIcatorsBtn" size="medium"
          >保 存</el-button
        >
      </div>
    </el-dialog>

    <!-- 提成比例弹框 -->
    <el-dialog
      class="dialog-ratio"
      width="30%"
      title="编辑提成比例"
      :visible.sync="dialogRatio"
    >
      <el-form>
        <el-form-item
          v-for="item in proportion"
          :key="item.drug_type"
          :label="`${item.drug_type_name}提成比例：`"
          :label-width="ratioFormLabelWidth"
        >
          <el-input-number
            size="small"
            :controls="false"
            :min="0"
            :max="0.99"
            :precision="2"
            v-model="item.proportion"
          ></el-input-number>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogRatio = false" size="medium">取 消</el-button>
        <el-button type="primary" @click="saveratio" size="medium"
          >保 存</el-button
        >
      </div>
    </el-dialog>

    <!-- 员工基础列表 -->
    <el-dialog
      title="员工列表"
      :visible.sync="staffListDia"
      :close-on-click-modal="false"
      width="800px"
      style="text-align: left"
    >
      <div style="padding: 20px">
        <div style="margin-bottom: 10px">
          <el-input
            v-model="searchStaffForm.keywords"
            placeholder="请输入"
            size="small"
            clearable
            maxlength="20"
            style="width: 200px"
          ></el-input>
          <el-button
            type="primary"
            @click="searchStaffBaseList"
            size="small"
            style="margin-left: 20px"
            >查询</el-button
          >
        </div>

        <el-table
          :data="staffBaseList"
          tooltip-effect="dark"
          height="500"
          style="width: 100%"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column prop="recommender_name" label="姓名" />
          <el-table-column prop="recommender_code" label="员工编码" />
          <el-table-column prop="phone" label="账号" />
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="confirmStaff(scope.row)"
                >选择当前员工</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="staffTotalNum > 0"
          :total="staffTotalNum"
          :page.sync="staffPagination.page"
          :limit.sync="staffPagination.pageNumber"
          @pagination="getStaffBaseList"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import Pagination from "@/components/Pagination";
import staff from "@/api/staff.js";
import { validPhone, validFloatNumber } from "@/service/utils/my-validate.js";
export default {
  components: {
    Pagination,
  },
  data() {
    const validateAccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入员工手机号"));
      }
      if (!validPhone(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const validateTimelimit = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请选择日期范围"));
      }
      if (value[0] === value[1]) {
        callback(new Error("存在重合时间段"));
      } else {
        callback();
      }
    };
    const validateIndicators = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入指标"));
      }
      if (!validFloatNumber(value)) {
        callback(new Error("请输入正确的10位数字/小数点"));
      } else {
        callback();
      }
    };
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      employeeForm: {
        phone: "",
        recommender_name: "",
        recommender_code: "",
        district_manager: "",
        district_manager_name: "",
        district_manager_phone: "",
        area_deputy_manager: "",
        area_deputy_manager_name: "",
        area_deputy_manager_phone: "",
        area_manager: "",
        area_manager_name: "",
        area_manager_phone: "",
      },
      employeeFormRules: {
        phone: [
          { required: true, message: "请输入员工手机号", trigger: "blur" },
          { validator: validateAccount, trigger: "blur" },
        ],
        recommender_name: [
          { required: true, message: "请输入员工姓名", trigger: "blur" },
        ],
        recommender_code: [
          { required: true, message: "请输入员工编号", trigger: "blur" },
        ],
      },
      tableHead: [
        {
          prop: "create_time",
          label: "创建时间",
        },
        {
          prop: "indicators_timelimit",
          label: "指标时限",
        },
        {
          prop: "target_money",
          label: "指标（元）",
        },
      ],
      employeeTable: [],
      dialogIndicators: false,
      indicatorsForm: {
        log_id: 0,
        indicators_timelimit: "",
        target_money: "",
      },
      indicatorsRules: {
        indicators_timelimit: [
          { required: true, message: "请输入日期范围", trigger: "blur" },
          { validator: validateTimelimit, trigger: "blur" },
        ],
        target_money: [
          { required: true, message: "请填写指标", trigger: "blur" },
          { validator: validateIndicators, trigger: "blur" },
        ],
      },
      dialogRatio: false,
      ratioForm: {
        slices: "",
        particles: "",
        patent: "",
        healthParty: "",
      },
      ratioFormLabelWidth: "200px",
      proportion: [],
      searchStaffForm: {
        key: "",
        keywords: "",
      },
      staffListDia: false,
      staffLoading: false,
      staffBaseList: [],
      staffTotalNum: 0,
      staffPagination: {
        page: 1,
        pageNumber: 10,
      },
    };
  },
  filters: {
    isAddText(val) {
      switch (val) {
        case "1":
          return "添加员工";
        case "0":
          return "编辑员工";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.routeQuery.is_add == 0) {
        this.employeeForm = Object.assign({}, this.routeQuery);
      }
      this.getIndicatorsList();
    },
    getIndicatorsList() {
      this.tableLoading = true;
      let params = Object.assign(
        {
          recommender_code: this.routeQuery.recommender_code,
        },
        this.pagination
      );
      staff.getStaffTargetList(params).then((res) => {
        let { list, total } = res.data;
        let tableData = [];
        for (let item of list) {
          let obj = {
            create_time: dayjs.unix(item.create_time).format("YYYY-MM-DD"),
            log_id: item.log_id,
            target_money: item.target_money,
            indicators_timelimit: `${dayjs
              .unix(item.target_start_time)
              .format("YYYY-MM-DD")} ~ ${dayjs
              .unix(item.target_end_time)
              .format("YYYY-MM-DD")}`,
          };
          tableData.push(obj);
        }
        this.employeeTable = tableData;
        this.totalNum = total;
        this.tableLoading = false;
      });
    },
    searchList() {
      this.getIndicatorsList();
    },
    resetForm() {
      let keyArr = Object.keys(this.employeeForm);
      if (this.routeQuery.is_add == 0) {
        keyArr.splice(
          keyArr.findIndex((item) => item === "recommender_code"),
          1
        );
      }
      for (let key of keyArr) {
        this.employeeForm[key] = "";
      }
      // this.$refs['employeeFormRef'].resetFields();
    },
    saveForm() {
      this.$refs["employeeFormRef"].validate((valid) => {
        if (valid) {
          let params = Object.assign(this.routeQuery, this.employeeForm);

          params = _.omit(params, [
            "district_manager_name",
            "district_manager_phone",
            "area_deputy_manager_name",
            "area_deputy_manager_phone",
            "area_manager_name",
            "area_manager_phone",
          ]);
          staff.saveStaffInfo(params).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success("保存成功");
              this.$router.replace({
                path: `/home/staff/employeeEditor?t=${new Date().valueOf()}`,
                query: Object.assign({ is_add: 0 }, this.employeeForm),
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addIndicators() {
      this.indicatorsForm = {
        indicators_timelimit: "",
        target_money: "",
      };
      this.dialogIndicators = true;
    },
    editBtn(row) {
      let index = row.indicators_timelimit.indexOf("~");
      let startTime = row.indicators_timelimit.substr(0, index);
      let endTime = row.indicators_timelimit.substr(index + 1);
      this.indicatorsForm = {
        log_id: row.log_id,
        target_money: row.target_money,
        indicators_timelimit: [startTime, endTime],
      };
      this.dialogIndicators = true;
    },
    delBtn(row) {
      this.$confirm("确定删除该指标吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          console.log(row);
          staff.deleteTargetInfo({ log_id: row.log_id }).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.init();
            }
          });
        })
        .catch(() => {});
    },
    cancelIndicatorsBtn() {
      this.dialogIndicators = false;
      this.$refs["indicatorsFormRef"].resetFields();
    },
    saveIndIcatorsBtn() {
      this.$refs["indicatorsFormRef"].validate((valid) => {
        if (valid) {
          let params = {
            log_id: this.indicatorsForm.log_id,
            recommender_code: this.routeQuery.recommender_code,
            target_start_time: this.indicatorsForm.indicators_timelimit[0],
            target_end_time: this.indicatorsForm.indicators_timelimit[1],
            target_money: this.indicatorsForm.target_money,
          };
          // console.log(params);
          staff.saveTargetInfo(params).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success("添加成功");
              this.getIndicatorsList();
              this.dialogIndicators = false;
              this.$refs["indicatorsFormRef"].resetFields();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getStaffProportionList() {
      if (this.employeeForm.recommender_code == "") {
        this.$message.warning("请填写员工信息");
        return;
      }
      staff
        .getStaffProportionList({
          recommender_code: this.employeeForm.recommender_code,
        })
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.dialogRatio = true;
            this.proportion = data.list;
          }
        });
    },
    // 提成比例
    saveratio() {
      if (this.employeeForm.recommender_code == "") {
        this.$message.warning("请输入员工编号");
        return;
      }
      let params = {
        recommender_code: this.employeeForm.recommender_code,
        proportion_info: this.proportion,
      };
      staff.setStaffProportionInfo(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success("保存成功");
          this.dialogRatio = false;
        }
      });
    },
    // 员工基础列表
    getStaffBaseList() {
      this.staffLoading = true;
      let searchParams = _.omit(this.searchStaffForm, ["key"]);
      let params = Object.assign({}, searchParams, this.staffPagination);
      staff
        .getStaffBaseList(params)
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            this.staffBaseList = data.list;
            this.staffTotalNum = data.total;
          }
          this.staffLoading = false;
        })
        .catch((err) => (this.staffLoading = false));
    },
    openStaffList(key) {
      this.staffListDia = true;
      this.searchStaffForm.key = key;
      this.getStaffBaseList();
    },
    delStaff(key) {
      this.employeeForm[key] = "";
      this.employeeForm[`${key}_name`] = "";
      this.employeeForm[`${key}_phone`] = "";
    },
    searchStaffBaseList() {
      this.staffPagination.page = 1;
      this.getStaffBaseList();
    },
    confirmStaff(row) {
      let { recommender_name, recommender_code, phone } = row;
      let { key } = this.searchStaffForm;
      this.employeeForm[key] = recommender_code;
      this.employeeForm[`${key}_name`] = recommender_name;
      this.employeeForm[`${key}_phone`] = phone;
      this.staffListDia = false;
    },
    back() {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  position: relative;
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.filterBox {
  line-height: 32px;
  height: 32px;
  margin-bottom: 20px;
  .box {
    line-height: 32px;
    height: 32px;
    margin-right: 20px;
    .label {
      margin-right: 10px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
  }
}
.employee-editor {
  .select-staff {
    ::v-deep .el-form-item__content {
      text-align: left;
    }
  }
  .page_title {
    display: flex;
    align-items: center;
    .el-breadcrumb__item {
      font-size: 18px;
    }
  }
  .employee-title {
    font-weight: bold;
    text-decoration: none;
    color: #262626;
    font-size: 20px;
    text-align: left;
    padding: 10px 0;
    display: flex;
    .el-button {
      margin-left: 20px;
    }
  }
  .employee-info {
    width: 40%;
    .info-btns {
      ::v-deep .el-form-item__content {
        // display: flex;
        text-align: left;
        // margin-left: 100px !important;
      }
    }
  }
  .add-indicators {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 10px;
  }
  .dialog-indicators {
    // ::v-deep .el-dialog__header {
    // }
    ::v-deep .el-dialog__body {
      padding-right: 20px !important;
      padding-top: 20px !important;
      .el-date-editor {
        width: 100%;
      }
      .indicators-box {
        .el-form-item__content {
          display: flex;
          align-items: center;
          .unit {
            padding: 0 0 0 6px;
          }
        }
      }
    }
  }
  .dialog-ratio {
    ::v-deep .el-dialog__body {
      height: 460px;
      padding-right: 20px !important;
      padding-top: 20px !important;
      overflow: auto;
      .el-form {
        .el-input-number {
          width: 100%;
        }
      }
    }
  }
}
</style>